import { useFilterLinkedinCardsStore } from "presentation/stores/use-filter-linkedincards-store";
import { Button } from "primereact/button";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import RequestLinkedinCardsDropdown from "../RequestLinkedinCardsDropdown";

const HeaderLinkedinCardsGrid: React.FC = () => {
  const [globalFilterValue, setGlobalFilterValue] = useState<string>("");
  const { filters, setFilters, resetFilters } = useFilterLinkedinCardsStore();

  const clearFilter = () => {
        resetFilters();
    }

    useEffect(() => {
      if (filters.query.value !== globalFilterValue) {
        setGlobalFilterValue(filters.query.value);
      }
    }, [filters]);

    const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === "Enter") {
          setFilters({
            ...filters,
            query: {
              ...filters.query,
              value: globalFilterValue
            }
          });
      }}
  


    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setGlobalFilterValue(e.target.value);
      };

    return (
        <div className="flex justify-content-between">
      <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            onKeyDown={onKeyDown}
            placeholder="Procurar"
          />
        </IconField>
        <RequestLinkedinCardsDropdown />
      </div>
      <div style={{ display: "flex" }}>
        <div style={{ width: "10px" }}></div>
        <Button
          type="button"
          icon="pi pi-filter-slash"
          label="Limpar"
          outlined
          onClick={clearFilter}
          style={{
            backgroundColor: "white",
            borderColor: "#2196f3",
            color: "#2196f3",
            borderRadius: "8px",
            marginRight: "15px",
          }}
        />
      </div>
    </div>
    );
};

export default HeaderLinkedinCardsGrid;
